import { facilityQueryKeys } from "@gymflow/api";
import { ApiType } from "@gymflow/common";
import { ApiListResponse, FacilityDTO } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import useGymflowModels from "apps/portal/src/store";

import { OptionType } from "./components/OptionsList/components/OptionItem";
import { SelectInput, SelectInputProps } from "./SelectInput";

export type FacilitySelectInputOptionType = OptionType<FacilityDTO>;

export type FacilitySelectInputProps = {
  extraParams?: Parameters<ApiType["facilityApi"]["find"]>[0]["extraParams"];
} & Omit<SelectInputProps<FacilityDTO>, "dataFetchingQuery">;

export const FacilitySelectInput = ({
  extraParams,
  ...props
}: FacilitySelectInputProps) => {
  const { api } = useGymflowModels();

  return (
    <SelectInput
      {...(props as SelectInputProps<FacilityDTO>)}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: facilityQueryKeys.list(),
          queryFn: async ({ pageParam }) =>
            (
              await api.facilityApi.find({
                extraParams: extraParams ? extraParams : { activeUser: true },
                page: pageParam,
              })
            ).data,
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              ApiListResponse<FacilityDTO>
            >;

            const transformedPages = pages.map((page) =>
              page.content.map((facility) => ({
                id: facility.id,
                label: facility.name,
                value: facility,
                imageUrl: facility.picture,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          getNextPageParam: (lastPage) => {
            const typedLastPage = lastPage as ApiListResponse<FacilityDTO>;
            return typedLastPage.last ? undefined : typedLastPage.number + 1;
          },
          initialPageParam: 0,
        })
      }
    />
  );
};
